
(function() {
  const swiper_Sections = document.querySelectorAll('[data-swiper_id^="swiper__controls_"]');
     
  if (swiper_Sections) {
    
      function convertBooleanToNumber(value) {
        return value === "true" ? 1 : 0;
      }

    swiper_Sections.forEach(swiper_Section => {
      const swiperId = swiper_Section.dataset.swiper_id;
      const navigation = convertBooleanToNumber(swiper_Section.dataset.navigation);
      const autoplay = convertBooleanToNumber(swiper_Section.dataset.autoplay);
      const slide_count = parseFloat(swiper_Section.dataset.slide_count);
      const slide_count_tab = parseFloat(swiper_Section.dataset.slide_count_tab);
      const slide_count_mobile = parseFloat(swiper_Section.dataset.slide_count_mobile);
      const centeredSlides = convertBooleanToNumber(swiper_Section.dataset.centeredslides);
      const loop = convertBooleanToNumber(swiper_Section.dataset.loop);
      const speed = parseInt(swiper_Section.dataset.speed);
      const speed_mobile = parseInt(swiper_Section.dataset.speed_mobile);
      const speed_tab = parseInt(swiper_Section.dataset.speed_tab);
      const spaceBetween = parseInt(swiper_Section.dataset.spacebetween);
      const spaceBetween_mobile = parseInt(swiper_Section.dataset.spacebetween_mobile);
      const pagination = convertBooleanToNumber(swiper_Section.dataset.pagination);
      const autoHeight = convertBooleanToNumber(swiper_Section.dataset.autoheight);
      const paginationType = swiper_Section.dataset.pagination_type;
      const freeMode = swiper_Section.dataset.freemode === "true";
      const effect = swiper_Section.dataset.effect;
      const rows = parseInt(swiper_Section.dataset.rows);
      const rows_mobile = parseInt(swiper_Section.dataset.rows_mobile);
      const allowTouchMove = convertBooleanToNumber(swiper_Section.dataset.allowtouchmove);
      
      const swiper = new Swiper(`[data-swiper_id="${swiperId}"] .swiper__Container`, {
        freeMode: freeMode,
        observer: true,
        observeParents: true,
        autoHeight: autoHeight,
        loop: loop,
        effect: effect,
        grabCursor: true,
        loopAddBlankSlides: true,
        spaceBetween: spaceBetween_mobile,
        preventClicks: true,
        preventClicksPropagation: true,
        pagination: {
          el: `[data-swiper_id="${swiperId}"] .swiper-pagination`,
          clickable: true,
        },
        scrollbar: {
          el: `[data-swiper_id="${swiperId}"] .swiper-scrollbar`,
        },
        keyboard: { enabled: true },
        navigation: {
          nextEl: `[data-swiper_id="${swiperId}"] .swiper-button-next`,
          prevEl: `[data-swiper_id="${swiperId}"] .swiper-button-prev`,
        },
        initialSlide: 0,
        autoplay: { enabled: autoplay, delay: speed },
        slidesPerView: slide_count_mobile,
        grid: {
          rows: rows_mobile,
        },
        centeredSlides: false,
        centeredSlidesBounds: false,
        slidesPerGroupSkip: 1,
        breakpoints: {
          768: {
            slidesPerView: slide_count_tab,
            centeredSlides: false,
            spaceBetween: spaceBetween_mobile,
            slidesPerGroupSkip: 1
          },
          1024: {
            slidesPerView: slide_count,
            centeredSlides: false,
            spaceBetween: spaceBetween,
            slidesPerGroupSkip: 1
          },
        },
      });
    });
  }
})();
